<template>
  <v-dialog max-width="500">
    <v-card class="rounded-lg">
      <div class="flex items-center justify-between py-2 pl-5 border-b">
        <img :src="info" alt="" class="w-7 h-7" />
        <h1 class="text-sm text-blue-600 font-medium pl-2">Détails</h1>
        <img
          :src="Button"
          class="ml-auto cursor-pointer pr-2"
          @click="closeModal"
        />
      </div>
      <div class="my-4">
        <div>
          <span class="text-base font-semibold pl-10 pt-6">
            Informations générales
          </span>
          <div class="rounded-md border-2 border-neutral-200 mx-10 my-4">
            <div class="p-4 grid grid-rows-1 gap-4">
              <CarteDetailsLine
                title="Ref interne"
                :body="'#' + enseignant.id"
              />
              <CarteDetailsLine
                title="Nom en arabe"
                :body="enseignant.nom_ar"
              />
              <CarteDetailsLine
                title="Prénom en arabe"
                :body="enseignant.prenom_ar"
              />
              <CarteDetailsLine title="CIN" :body="enseignant.cin" />
              <CarteDetailsLine
                v-if="enseignant.cin != enseignant.cin_off"
                title="CIN officiel"
                :body="enseignant.cin_off"
              />
            </div>
          </div>
        </div>
        <div>
          <span class="text-base font-semibold pl-10 pt-6">
            Informations personnels
          </span>
          <div class="rounded-md border-2 border-neutral-200 mx-10 my-4">
            <div class="p-4 grid grid-rows-1 gap-4">
              <CarteDetailsLine
                title="Identifiant unique"
                :body="enseignant.identifiant_unique"
              />
              <CarteDetailsLine
                title="Date de naissance"
                :body="enseignant.date_naissance"
              />
              <CarteDetailsLine
                title="Lieu de naissance"
                :body="enseignant.lieu_naissance"
              />

              <CarteDetailsLine
                title="Lieu de naissance en arabe"
                :body="enseignant.lieu_naissance_ar"
              />
            </div>
          </div>
        </div>
        <div v-if="enseignant.justificatif1 || enseignant.justificatif2">
          <span class="text-base font-semibold pl-10 pt-6">Pièces jointes</span>
          <div
            class="rounded-md border-2 border-neutral-200 mx-10 my-4 flex justify-center"
          >
            <div class="p-4 flex gap-4">
              <a
                v-if="enseignant.justificatif1"
                :href="api_url + '/uploads/' + enseignant.justificatif1"
                target="_blank"
              >
                <GradientButton icon="mdi-download" type="soft">
                  Pièce jointe n°1
                </GradientButton>
              </a>
              <a
                target="_blank"
                v-if="enseignant.justificatif2"
                :href="api_url + '/uploads/' + enseignant.justificatif2"
              >
                <GradientButton icon="mdi-download" type="soft">
                  Pièce jointe n°2
                </GradientButton>
              </a>
            </div>
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import plus from '../../assets/plus-sm.png';
import Button from '../../assets/Button.png';
import info from '../../assets/info.svg';
import fileDownload from '../../assets/fileDownload.svg';

import GradientButton from '../Buttons/GradientButton/GradientButton.vue';
import apolloClient from '@/apolloClient';
import {GET_ENSEIGNANT_BY_ID} from '@/SPA/Enseignants/EnseignantList.service';
import CarteDetailsLine from './CarteDetailsLine.vue';

const api_url = process.env.VUE_APP_API_URL;

export default {
  name: 'CarteDetailsEnseignant',
  components: {
    GradientButton,
    CarteDetailsLine,
  },
  props: {
    id: Number,
  },
  data() {
    return {
      modalOpen: false,
      plus,
      Button,
      info,
      fileDownload,
      api_url,
      enseignant: {},
    };
  },

  methods: {
    openModal() {
      this.modalOpen = true;
      this.$emit('showDetails');
    },
    closeModal() {
      this.modalOpen = false;
      this.$emit('update:modelValue', false);
    },
    handleGetEnseignant(id) {
      apolloClient
        .query({
          query: GET_ENSEIGNANT_BY_ID,
          variables: {
            id,
          },
          fetchPolicy: 'no-cache',
        })
        .then(res => {
          this.enseignant = res.data.getEnseignantById;
        });
    },
  },
  watch: {
    id(newVal) {
      this.handleGetEnseignant(newVal);
    },
  },
  mounted() {
    this.handleGetEnseignant(this.id);
  },
};
</script>
